import { render } from "./Home.vue?vue&type=template&id=ae52c670&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=ae52c670&lang=css&scoped=true"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae52c670"]])

export default __exports__